import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductsComponent } from './products/products.component';
import { PricingComponent } from './pricing/pricing.component';
import { ErrorComponent } from './error/error.component';
import { AuthGuard, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { environment } from './../../environments/environment';
import { PrivacyComponent } from './privacy/privacy.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { TOSComponent } from './tos/tos.component';
import { RecordingViewComponent } from './recording-viewer/recording-viewer.component';
import { TeamRecordingsComponent } from './team-recordings/team-recordings.component';
import { TeamListComponent } from './team-list-recordings/team-list-recordings.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { SignedOutComponent } from './signed-out/signed-out.component';
import { teamMemberGuard } from '../shared/team-member.guard';
import { rootRedirectGuard } from '../shared/root-redirect.guard';

const redirectUnauthorizedToLogin = () =>  redirectUnauthorizedTo(['/user']) ;
const redirectLoggedInToItems = () => redirectLoggedInTo(['/app']);

let routes: Routes = [
  {
    // Resolve the bare domain only after Firebase has restored the auth state.
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [rootRedirectGuard],
  },
  // Permanently public so signed-in users can still visit the marketing site.
  { path: 'home', component: HomeComponent },
  // Also unguarded: this is the application home page URL on the OAuth consent screen.
  { path: 'products', component: ProductsComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'app', loadChildren: () => import('./app/app.module').then(m => m.AppModule), canActivate: [AuthGuard, teamMemberGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule), data: { authGuardPipe: redirectLoggedInToItems } },
  { path: 'error', component: ErrorComponent },
  { path: 'no-access', component: NoAccessComponent },
  { path: 'signed-out', component: SignedOutComponent },
  { path: 'privacy', component: PrivacyComponent },
  // Unguarded on purpose: this is the account-deletion URL published to Google Play.
  { path: 'delete-account', component: DeleteAccountComponent },
  { path: 'tos', component: TOSComponent },
  { path: 'teams', component: TeamListComponent, canActivate: [AuthGuard, teamMemberGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'viewer/:id', component: RecordingViewComponent },
  { path: 'teamRecordings/:id', component: TeamRecordingsComponent },
  { path: '**', redirectTo: '/error' }
];

if (!environment.isAuthGuardActive) {
  routes = [
    {
      // Resolve the bare domain only after Firebase has restored the auth state.
      path: '',
      component: HomeComponent,
      pathMatch: 'full',
      canActivate: [rootRedirectGuard],
    },
    // Permanently public so signed-in users can still visit the marketing site.
    { path: 'home', component: HomeComponent },
    // Also unguarded: this is the application home page URL on the OAuth consent screen.
    { path: 'products', component: ProductsComponent },
    { path: 'pricing', component: PricingComponent },
    { path: 'app', loadChildren: () => import('./app/app.module').then(m => m.AppModule) },
    { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
    { path: 'error', component: ErrorComponent },
    { path: 'no-access', component: NoAccessComponent },
    { path: 'signed-out', component: SignedOutComponent },
    { path: 'privacy', component: PrivacyComponent },
  // Unguarded on purpose: this is the account-deletion URL published to Google Play.
  { path: 'delete-account', component: DeleteAccountComponent },
    { path: 'tos', component: TOSComponent },
    { path: 'teams', component: TeamListComponent },
    { path: 'recording/:id/viewer', component: RecordingViewComponent },
    { path: 'teamRecordings/:id', component: TeamRecordingsComponent },
    { path: '**', redirectTo: '/error' }
  ];
}
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewRoutingModule { }
